/** Default page size for catalog GraphQL requests (replaces former 10_000 bulk fetch). */
export const CATALOG_PAGE_SIZE = 100;

/** Max bookings loaded per shop in a single request. */
export const BOOKINGS_QUERY_LIMIT = 50;
